import { render, staticRenderFns } from "./RegisterBaseData.vue?vue&type=template&id=fc7379f8&"
import script from "./RegisterBaseData.vue?vue&type=script&lang=ts&"
export * from "./RegisterBaseData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports